import { Link } from '@tanstack/react-router'
import { CatalogGridViewModel } from '@/components/catalog/catalog-grid/catalog-grid.view-model'
import { CategoryHeaderViewModel } from '@/components/catalog/category-header/category-header.view-model'
import type { useCategoryPageModel } from '@/components/catalog/category-page/category-page.model'
import { ConversionBandViewModel } from '@/components/shared/conversion-band/conversion-band.view-model'

type CategoryPageViewProps = ReturnType<typeof useCategoryPageModel>

export function CategoryPageView({
  category,
  products,
  isEmpty,
  gridContainerRef,
}: CategoryPageViewProps) {
  return (
    <div className="fz-category-page">
      <CategoryHeaderViewModel category={category} count={products.length} />
      {isEmpty ? (
        <div className="fz-catalog-page__empty">
          <p className="fz-catalog-page__empty-text">
            Ainda não temos criações cadastradas nesta categoria.
          </p>
          <Link to="/catalogo" className="fz-catalog-page__empty-link">
            Ver tudo
          </Link>
        </div>
      ) : (
        <div ref={gridContainerRef}>
          <CatalogGridViewModel products={products} />
        </div>
      )}
      <ConversionBandViewModel />
    </div>
  )
}
